// TODO refactor to use the context and an expand function

const Iris = {
  xsdString: 'http://www.w3.org/2001/XMLSchema#string',
  xsdDateTime: 'http://www.w3.org/2001/XMLSchema#dateTime',
  xsdDate: 'http://www.w3.org/2001/XMLSchema#date',
  rdfLangString: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString',
  owlNamedIndividual: 'http://www.w3.org/2002/07/owl#NamedIndividual',
  recHasPopularName: 'https://w3id.org/rec/core/hasPopularName',
  recHasLittera: 'https://w3id.org/rec/core/hasLittera',
  casoHasPropertyRegisterDesignation:
    'https://rec.castellum.se/ontology/hasPropertyRegisterDesignation',
  woboHasPropertyRegisterDesignation:
    'https://rec.webofbuildings.com/ontology/hasPropertyRegisterDesignation',
  recName: 'https://w3id.org/rec#name',
  recAddressLine: 'https://w3id.org/rec#addressLine1',
  recPostalCode: 'https://w3id.org/rec#postalCode',
  recCity: 'https://w3id.org/rec#city',
  // WOBO classes shall be in wob-client.
  woboApartmentNumber: 'https://webofbuildings.com/ontology/apartmentNumber',
  woboDesignation: 'https://webofbuildings.com/ontology/designation',
  recPostalAddress: 'https://w3id.org/rec#PostalAddress',
  recPoint: 'https://w3id.org/rec#Point',
  recCoordinates: 'https://w3id.org/rec#coordinates',
  recValue: 'https://w3id.org/rec#value',
  recTimestamp: 'https://w3id.org/rec#timestamp',
  recEnd: 'https://w3id.org/rec#end',
  recStart: 'https://w3id.org/rec#start',
  recLocatedIn: 'https://w3id.org/rec#locatedIn',
  recIsLocationOf: 'https://w3id.org/rec#isLocationOf',
  recIsPartOf: 'https://w3id.org/rec#isPartOf',
  recIsPointOf: 'https://w3id.org/rec#isPointOf',
  recSourcePoint: 'https://w3id.org/rec#sourcePoint',
  recIncludes: 'https://w3id.org/rec#includes',
  recLastKnownValue: 'https://w3id.org/rec#lastKnownValue',
  recIdentifiers: 'https://w3id.org/rec#identifiers',
  rdfJSON: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#JSON',
  brickIsPointOf: 'https://brickschema.org/schema/Brick#isPointOf',
  brickFeeds: 'https://brickschema.org/schema/Brick#feeds',
  recRealEstate: 'https://w3id.org/rec#RealEstate',
  recSpace: 'https://w3id.org/rec#Space',
  recBuilding: 'https://w3id.org/rec#Building',
  recSubBuilding: 'https://w3id.org/rec#SubBuilding',
  recLevel: 'https://w3id.org/rec#Level',
  recRoom: 'https://w3id.org/rec#Room',
  brickSystem: 'https://brickschema.org/schema/Brick#System',
  brickEquipment: 'https://brickschema.org/schema/Brick#Equipment',
  // TODO temporarily added as the loaded ontology uses the rec, not brick, sensor equipments...
  brickSensorEquipment: 'https://brickschema.org/schema/Brick#Sensor_Equipment',
  brickPoint: 'https://brickschema.org/schema/Brick#Point',
  recAgent: 'https://w3id.org/rec#Agent',
  recOwns: 'https://w3id.org/rec#owns',
  recFamilyName: 'https://w3id.org/rec#familyName',
  recGivenName: 'https://w3id.org/rec#givenName',
  recRelatedTo: 'https://w3id.org/rec#relatedTo',
  recServiceObject: 'https://w3id.org/rec#ServiceObject',
  recAsset: 'https://w3id.org/rec#Asset',
  // Asset data properties (from DTDL Asset interface)
  recIPAddress: 'https://w3id.org/rec#IPAddress',
  recMACAddress: 'https://w3id.org/rec#MACAddress',
  recAssetTag: 'https://w3id.org/rec#assetTag',
  recCommissioningDate: 'https://w3id.org/rec#commissioningDate',
  recInitialCost: 'https://w3id.org/rec#initialCost',
  recInstallationDate: 'https://w3id.org/rec#installationDate',
  recModelNumber: 'https://w3id.org/rec#modelNumber',
  recSerialNumber: 'https://w3id.org/rec#serialNumber',
  recTurnoverDate: 'https://w3id.org/rec#turnoverDate',
  recWeight: 'https://w3id.org/rec#weight',
  // Asset properties to exclude from UI
  recCustomTags: 'https://w3id.org/rec#customTags',
  recCustomProperties: 'https://w3id.org/rec#customProperties',
  // Asset relationship properties (object properties)
  recServicedBy: 'https://w3id.org/rec#servicedBy',
  recManufacturedBy: 'https://w3id.org/rec#manufacturedBy',
  recInstalledBy: 'https://w3id.org/rec#installedBy',
  recCommissionedBy: 'https://w3id.org/rec#commissionedBy',
  recMountedOn: 'https://w3id.org/rec#mountedOn',
  // Additional REC classes for relationship targets
  recBuildingElement: 'https://w3id.org/rec#BuildingElement',
  recArchitecture: 'https://w3id.org/rec#Architecture',
  recSystem: 'https://w3id.org/rec#System',
  // Brick Curve Semantics - Classes
  brickFunction: 'https://brickschema.org/schema/Brick#Function',
  brickCurveFunction: 'https://brickschema.org/schema/Brick#Curve_Function',
  brickTemperatureCurveFunction:
    'https://brickschema.org/schema/Brick#Temperature_Curve_Function',
  brickSupplyAirPressureCurveFunction:
    'https://brickschema.org/schema/Brick#Supply_Air_Pressure_Curve_Function',
  brickReturnAirPressureCurveFunction:
    'https://brickschema.org/schema/Brick#Return_Air_Pressure_Curve_Function',
  brickFictivePowerFunction:
    'https://brickschema.org/schema/Brick#Fictive_Power_Function',
  brickBreakPointPair: 'https://brickschema.org/schema/Brick#Break_Point_Pair',
  brickIndependentBreakPoint:
    'https://brickschema.org/schema/Brick#Independent_Break_Point',
  brickDependentBreakPoint:
    'https://brickschema.org/schema/Brick#Dependent_Break_Point',
  brickVariableAirVolumeSystem:
    'https://brickschema.org/schema/Brick#Variable_Air_Volume_System',
  brickVariableAirVolumeCoolingBeam:
    'https://brickschema.org/schema/Brick#Variable_Air_Volume_Cooling_Beam',
  brickMaxReturnAirStaticPressureSetpointLimit:
    'https://brickschema.org/schema/Brick#Max_Return_Air_Static_Pressure_Setpoint_Limit',
  brickMinReturnAirStaticPressureSetpointLimit:
    'https://brickschema.org/schema/Brick#Min_Return_Air_Static_Pressure_Setpoint_Limit',
  // Brick Curve Semantics - Relationships
  brickInput: 'https://brickschema.org/schema/Brick#input',
  brickHasIndependentBreakPoint:
    'https://brickschema.org/schema/Brick#hasIndependentBreakPoint',
  brickHasDependentBreakPoint:
    'https://brickschema.org/schema/Brick#hasDependentBreakPoint',
  brickIsBreakPointPairOf:
    'https://brickschema.org/schema/Brick#isBreakPointPairOf',
  // Brick Curve Semantics - Properties
  brickPairIndex: 'https://brickschema.org/schema/Brick#pairIndex',
}

const Jsonld = {
  id: '@id',
  type: '@type',
  context: '@context',
  value: '@value',
  language: '@language',
}

class Value {
  constructor(value) {
    this._value = value
  }
  get value() {
    return this._value
  }
  set value(value) {
    this._value = value
  }
  // Parameter value is either a Value instance or a string.
  equals(value) {
    return (value?.value || value) == this._value
  }
  clone() {
    return new this.constructor(this._value)
  }
}

// TODO allow for no namespaces, shorten may be implemented, prefix will have to be equal to value.
// TODO perhaps run expander on constructor...
class Iri extends Value {
  constructor(value = '', namespaces = null) {
    super(value)
    this._namespaces = namespaces
    this._prefixed = namespaces?.prefix(value) || value
    this._short = namespaces?.shorten(value) || value
  }
  get prefixed() {
    return this._prefixed
  }
  get short() {
    return this._short
  }
  get isDefined() {
    return !!this._value
  }
  clone() {
    return new this.constructor(this._value, this._namespaces)
  }
}

class Literal extends Value {
  constructor(value = '', datatype = Iris.xsdString) {
    super(value)
    this._datatype = datatype
  }
  get datatype() {
    return this._datatype
  }
  // TODO rename to literal...
  equals(value) {
    return (
      Value.prototype.equals.call(this, value) &&
      value?.datatype == this._datatype
    )
  }
  clone() {
    return new this.constructor(this._value, this._datatype)
  }
}

class JsonLiteral extends Literal {
  constructor(value) {
    super(value, Iris.rdfJSON)
  }
}

class LanguageString extends Literal {
  constructor(value, language) {
    super(value, Iris.rdfLangString)
    this._language = language
  }
  get language() {
    return this._language
  }
  // TODO rename...
  equals(value) {
    return (
      Value.prototype.equals.call(this, value) &&
      value?.datatype == Iris.rdfLangString &&
      value?.language == this._language
    )
  }
  clone() {
    return new this.constructor(this._value, this._language)
  }
}

// A Property comprises a name IRI and an array of Value objects.
// TODO add safeguard to ensure the values are indeed typed as Value...
class Property {
  constructor(name, ...values) {
    this._name = name instanceof Iri ? name : new Iri(name)
    this._values = values
  }
  get name() {
    return this._name
  }
  get values() {
    return this._values
  }
  get size() {
    return this._values.length
  }
  get isEmpty() {
    return this._values.length == 0
  }
  get isOne() {
    return this._values.length == 1
  }
  // TODO the methods should only accept instances of Value and its descendants as casting to Value doesnt comapre with Literal etc.
  addValue(v) {
    const value = v instanceof Value ? v : new Value(v)
    if (!this._values.find((v) => v.equals(value))) this._values.push(value)
    return this
  }
  removeValue(v) {
    const value = v instanceof Value ? v : new Value(v)
    this._values = this._values.filter((v) => !v.equals(value))
    return this
  }
  updateValue(oldV, newV) {
    return this.removeValue(oldV).addValue(newV)
  }
  setValue(index, newV) {
    return this._values.splice(index, 1, newV)
    // TODO changed to support reactivity in vue 2
    // return (this._values[index] = newV)
  }
  hasValue(v) {
    const value = v instanceof Value ? v : new Value(v)
    return !!this._values.find((v) => v.equals(value))
  }
  clone() {
    return new this.constructor(
      this._name.clone(),
      ...this._values.map((v) => v.clone())
    )
  }
  // Overwritten in the subclasses.
  toJSONLD() {}
}

// Each value in values may be a string or an object { @value, [ @language ] }.
// TODO with expanded form its always an object.
class DataProperty extends Property {
  constructor(name = '', ...values) {
    // TODO expects values to be formated as Value descendents...
    super(name, ...values)
    // super(
    //   name,
    //   ...values.map((v) =>
    //     typeof v == 'string'
    //       ? new Literal(v)
    //       : v[Jsonld.language]
    //       ? new LanguageString(v[Jsonld.value], v[Jsonld.language])
    //       : new Literal(v[Jsonld.value])
    //   )
    // )
  }
  toJSONLD() {
    const jsonld = {}
    jsonld[this.name.value] = this.values.map((v) => {
      if (v.datatype === Iris.rdfJSON) {
        return { '@value': v.value, '@type': '@json' }
      }
      // Include @type for non-string datatypes (dateTime, date, etc.)
      if (v.datatype && v.datatype !== Iris.xsdString) {
        return { '@value': v.value, '@type': v.datatype }
      }
      return { '@value': v.value }
    })
    return jsonld
  }
}

// TODO redo to a JsonProperty inheriting from property
// Let the client mark it as json literal
// Potentially override the addvalue to only allow one value in the values array
// The client needs an array of json literals mappings to look out for, must be set at construction, eg indetifiers
// Create a JsonProp component to render for literals, copy the data property
// This component can render accorign to different map types (string, boolean etc) based on name

// The JSON property holds at maximum one value, an object, in its values array.
// Parameter name is an Iri and value is an object.
//
// TODO consider saving the map in a JSON structure...
// Parameter name is an Iri and keyValuePairs are key-value pairs in array form [key, value][] with both key and value being strings.
// class StringMapDataProperty extends DataProperty {
//   constructor(name, ...keyValuePairs) {
//     super(name, ...keyValuePairs)
//   }
//   // Parameter v is a key-value pair in array form [key, value] with value being a string.
//   addValue(v) {
//     // const [key, value] = v
//     // TODO check if key is present. Throw if so.
//     console.log('STRING MAP ADD VALUE', v)
//     this.values.push(v)
//     return this
//   }
//   // Parameter v is a key-value pair in array form [key, value] with value being a string.
//   removeValue(v) {
//     // TODO perhaps better to do a base class fixing keys and then extend from there...
//     const [key, value] = v
//     // TODO check if key is present. Throw if not so.
//     console.log('STRING MAP REMOVE VALUE', v)
//     this.values = this.values.filter(value)
//     return this
//   }
// }

// Each value in values is an IRI.
// TODO introduce check for type in values.
class ObjectProperty extends Property {
  constructor(name, ...values) {
    super(
      name,
      ...values.map((v) => (v instanceof Iri ? v : new Iri(v[Jsonld.value])))
    )
  }
  toJSONLD() {
    const jsonld = {}
    jsonld[this.name.value] = this.values.map((v) => ({ '@id': v.value }))
    return jsonld
  }
}

export {
  Iris,
  Jsonld,
  Value,
  Iri,
  Literal,
  JsonLiteral,
  LanguageString,
  Property,
  DataProperty,
  // JsonProperty,
  ObjectProperty,
}
